import { useMemo } from 'react';
import { useResolvedTheme } from '@/theme/theme';
import { envelopeUri, type EnvelopeState } from '@/art/envelope';

/** Red envelope art (decorative; the caller gives the accessible label). */
export function EnvelopeArt({ state, width }: { state: EnvelopeState; width: number }) {
  const theme = useResolvedTheme();
  const src = useMemo(() => envelopeUri(state, theme), [state, theme]);
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      draggable={false}
      width={width}
      height={Math.round((width * 128) / 96)}
      style={{ display: 'block', flex: 'none' }}
    />
  );
}
